import React from 'react';
import PropTypes from 'prop-types';
import {createFragmentContainer} from 'react-relay';
import clsx from 'clsx';

import graphql from 'babel-plugin-relay/macro';

import withWidth from '@material-ui/core/withWidth';
import withStyles from '@material-ui/core/styles/withStyles';

import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';

import NavContent from './NavContent';

import {StateContext} from './context';
import {DispatchContext} from './context';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);

const drawer_width = 300;


const styles = theme => {
  console.log("transitions: ",theme.transitions.create(['width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }));
  console.log("theme.transitions.duration: ",theme.transitions.duration);
  console.log("theme.transitions.easing: ",theme.transitions.easing);
  console.log("cur: ",theme.transitions.create(['width'], {
    easing: theme.transitions.easing.standard,
    duration: theme.transitions.duration.enteringScreen,
  }));

  return {
  drawer: {
    width: drawer_width,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawer_width,
    transition: theme.transitions.create(['width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create(['width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    //transition: 'width 1.3s cubic-bezier(0.4, 0, 0.2, 1)',
    overflowX: 'hidden',
    width: 0,
    border:'none',
  },
  container: {
    width:'100%',
    margin:0,
    background:theme.palette.white,
    transition: theme.transitions.create(['width','margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    })
  },
  container_open: {
    marginLeft: drawer_width,
    width: `calc(100% - ${drawer_width}px)`,
    transition: theme.transitions.create(['width','margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
 }
}

const add_slash_to_path = path => Boolean(path) && /^\//.test(path) ? path : Boolean(path) ? '/' + path : '/';


const handleResize = matches => {
  return {
    small_menu_open: false,
    big_menu_open: matches,
    matches
  }
};

let update_state;

const NavDrawer = ({
  children,
  classes: {
    drawer,
    drawerClose,
    drawerOpen,
    container,
    container_open,
  },
  ...props
}) => {

  const matches = useMediaQuery('(min-width:1280px)');
  const [state, set] = React.useState(handleResize(matches));

  function toggleDrawer () {

    const drawer = matches ? 'big_menu_open':'small_menu_open';
    set({ ...state, [drawer]: !state[drawer] });
  }

  const { big_menu_open, small_menu_open } = state;

  React.useEffect(() => {
    if (state.matches !== matches) {
      set(handleResize(matches))
    }
  }, [matches])

  //const drawer_class = drawer + ' ' + ( big_menu_open ? drawerOpen : drawerClose );
  //const container_class = container + (big_menu_open ? ` ${container_open}` : '');

  const [orgs_state, select_org_property] = React.useState({
    selected_property: {
      id: props.user.property_id,
      name: props.user.property
    },
    selected_org: {
      id: props.user.org_id,
      name: props.user.org
    }
  });

  async function handle_select_org_property(new_state) {

    select_org_property(new_state);

    const new_state_has_property = Boolean(new_state.selected_property && new_state.selected_property.id);

    if (!new_state_has_property) { return; }

    if (update_state) {

      if (typeof props.onSelect === "function") {
          await props.onSelect(new_state)
      }
      if (!matches) {
        toggleDrawer(false);
      }

    }
    else {
      update_state = true;
    }

  }

  return (
    <div>
      <StateContext.Provider value = {orgs_state}>
        <div className = {clsx(
            container,
            {
              [container_open]: big_menu_open,
            }
          )
          }>
          { React.cloneElement(children, { toggleDrawer }) }
        </div>
        <Hidden lgUp implementation="css">
           <SwipeableDrawer
             disableBackdropTransition={!iOS}
             disableDiscovery={iOS}
             variant="temporary"
             open={small_menu_open}
             onClose={e => toggleDrawer(false)  }
             onOpen={e => toggleDrawer(true)  }
          >
              <NavContent
                {...props}
                menu_open = {big_menu_open}
                onClose = { e => toggleDrawer(false)}
                select_org_property= {handle_select_org_property}
                orgs_state = {orgs_state}
              />
          </SwipeableDrawer>
        </Hidden>
        <Drawer
          variant="permanent"
          open
          className = { clsx(
              drawer,
              {
                [drawerOpen]: big_menu_open,
                [drawerClose]: !big_menu_open
              }
            )
          }
          classes = {{
            paper: clsx({
              [drawerOpen]: big_menu_open,
              [drawerClose]: !big_menu_open
            })
          }}
        >
            <NavContent
              {...props}
              menu_open = {big_menu_open}
              onClose = { e => toggleDrawer(false)}
              select_org_property = {handle_select_org_property}
              orgs_state = {orgs_state}
            />
      </Drawer>
    </StateContext.Provider>
  </div>
);
}

NavDrawer.propTypes = {
  classes: PropTypes.shape({
    drawer: PropTypes.string.isRequired,
    drawerClose: PropTypes.string.isRequired,
    drawerOpen: PropTypes.string.isRequired,
  }),
  children: React.isValidElement,
  pathname: PropTypes.string.isRequired
}

NavDrawer.defaultProps = {
  children: (<div></div>),
  pathname: '/'
}

export default React.memo(withStyles(styles)(NavDrawer));
